import React from 'react'
import { AnimatePresence } from 'framer-motion'
import Layout from './src/components/layout'

import 'swiper/css'
import 'swiper/css/navigation'

import './src/normalize.css'
import './src/style.css'

export const wrapPageElement = ({ element }) => (
  <Layout>
    <AnimatePresence mode="wait">{element}</AnimatePresence>
  </Layout>
)
